import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { ModeEnum } from "../../../src/taskpane/components/enums/modeEnum";
import shareToTeams from "../../Services/ShareToTeamsService";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/redux";
import { getFileItemIdFromRelativePath, getItemWebViewUrl } from "../../../src/taskpane/services/GraphService";
import authModule from "../../../utilities/AuthModule";

const getItemId = async (selectedItem: any, driveId: string) => {
    let itemId: string;
    try {
        const spItemUrlparts = selectedItem[".spItemUrl"]?.split("/");
        if (Array.isArray(spItemUrlparts) && spItemUrlparts.length > 0) {
            itemId = spItemUrlparts[spItemUrlparts.length - 1]?.split("?")[0];
        }
        if (!itemId) {
            const driveUrl = new URL(await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, null));
            const folderUrl = new URL(driveUrl.origin + selectedItem.FileRef);
            itemId = await getFileItemIdFromRelativePath(await authModule.getGraphAccessToken(), driveId, folderUrl.pathname.replace(driveUrl.pathname, ""), false);
        }
    } catch (error) {
        // Ignore
    }
    return itemId;
};

export function useMenuItem_ShareToTeams(selectedItems, isInOneDrive, setWaitFor, setWaitForContext, mode) {
    const languageStrings = React.useContext(LanguageContext);
    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const oneDriveRootDetails = useSelector((state: RootState) => state.workingDirectories.oneDriveRootDetails);

    const shareToTeamsHandler = React.useCallback(async () => {
        setWaitForContext(languageStrings.Sending);
        setWaitFor(true);
        const item = selectedItems[0];
        const driveId = !isInOneDrive ? (!currentDirectory.parentId ? currentDirectory.id : currentDirectory.parentId) : oneDriveRootDetails.driveId;
        const itemId: string = await getItemId(item, driveId);
        const isDocument = item?.File_x0020_Type !== "";
        const fileName = item?.FileLeafRef;
        const contentTypeId = item?.ContentTypeId;
        const driveUrl = new URL(await getItemWebViewUrl(await authModule.getGraphAccessToken(), driveId, null));
        const url = new URL(driveUrl.origin + item.FileRef).href;

        shareToTeams(
            driveId,
            itemId,
            isDocument,
            fileName,
            contentTypeId,
            url
        );

        setWaitFor(false);
    }, [selectedItems, isInOneDrive, currentDirectory, oneDriveRootDetails, setWaitFor, setWaitForContext]);

    const menuItem_ShareToTeams = React.useMemo(() => {
        if (mode === ModeEnum.contentManagerTeams) {
            return {
                key: "SendAsMessage",
                text: `${languageStrings.ShareToTeams}`,
                iconProps: { iconName: "TeamsLogo" },
                onClick: () => { shareToTeamsHandler() }
            } as IContextualMenuItem;
        }
        return null;
    }, [mode, shareToTeamsHandler]);

    return {
        menuItem_ShareToTeams
    }
}